export default __webpack_public_path__ + "static/aw-d3645f84fc5a816579c1a79cd11671db.svg";